import { render, staticRenderFns } from "./QuestionsResponse.vue?vue&type=template&id=474f7310"
import script from "./QuestionsResponse.vue?vue&type=script&lang=js"
export * from "./QuestionsResponse.vue?vue&type=script&lang=js"
import style0 from "./QuestionsResponse.vue?vue&type=style&index=0&id=474f7310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports